import * as v from "valibot";

// ── R2 Upload ──────────────────────────────────────────────

export const SimpleUploadResponseSchema = v.object({
  key: v.string(),
  presignedUrl: v.string(),
  url: v.string(),
});

export const CreateUploadResponseSchema = v.object({
  key: v.string(),
  partSize: v.number(),
  presignedUrls: v.array(v.string()),
  uploadId: v.string(),
});

export const CompleteUploadResponseSchema = v.object({
  key: v.string(),
  url: v.string(),
});

// ── Payment ────────────────────────────────────────────────

export const PaymentIntentResponseSchema = v.object({
  clientSecret: v.string(),
});

// ── Event Row (Supabase response) ──────────────────────────

const EventTicketKindSchema = v.object({
  currency: v.string(),
  description: v.nullable(v.string()),
  id: v.string(),
  price_cents: v.number(),
  price_service_fee: v.nullable(v.number()),
  quantity_sold: v.nullable(v.number()),
  quantity_total: v.nullable(v.number()),
  status: v.string(),
});

export const EventRowSchema = v.object({
  description: v.nullable(v.string()),
  ends_at: v.nullable(v.string()),
  event_member: v.optional(v.array(v.object({ role: v.string() }))),
  event_ticket_kind: v.array(EventTicketKindSchema),
  flyer_url: v.optional(v.nullable(v.string())),
  id: v.string(),
  location_city: v.nullable(v.string()),
  location_geo: v.nullable(v.string()),
  location_name: v.nullable(v.string()),
  location_neighborhood: v.optional(v.nullable(v.string())),
  location_place_id: v.optional(v.nullable(v.string())),
  location_postal_code: v.nullable(v.string()),
  location_state: v.nullable(v.string()),
  location_street: v.nullable(v.string()),
  slug: v.nullable(v.string()),
  starts_at: v.nullable(v.string()),
  status: v.string(),
  title: v.nullable(v.string()),
  visibility: v.optional(v.string()),
});

export type EventRow = v.InferOutput<typeof EventRowSchema>;

// ── Upcoming Events View (flat row, no nested relations) ────

export const UpcomingEventRowSchema = v.object({
  created_by_user_id: v.string(),
  description: v.nullable(v.string()),
  ends_at: v.nullable(v.string()),
  flyer_url: v.nullable(v.string()),
  id: v.string(),
  location_city: v.nullable(v.string()),
  location_country: v.nullable(v.string()),
  location_geo: v.nullable(v.string()),
  location_name: v.nullable(v.string()),
  location_neighborhood: v.optional(v.nullable(v.string())),
  location_place_id: v.nullable(v.string()),
  location_postal_code: v.nullable(v.string()),
  location_state: v.nullable(v.string()),
  location_street: v.nullable(v.string()),
  member_role: v.nullable(v.string()),
  member_user_id: v.nullable(v.string()),
  rsvp_status: v.nullable(v.string()),
  slug: v.nullable(v.string()),
  starts_at: v.nullable(v.string()),
  status: v.string(),
  timezone: v.nullable(v.string()),
  title: v.nullable(v.string()),
  visibility: v.string(),
});

export type UpcomingEventRow = v.InferOutput<typeof UpcomingEventRowSchema>;

// ── Event Member Detail (v1_event_member_detail view) ───────

export const EventMemberDetailSchema = v.object({
  is_contact: v.boolean(),
  name: v.nullable(v.string()),
  role: v.string(),
  rsvp_status: v.string(),
  user_id: v.string(),
});

export type EventMemberDetail = v.InferOutput<typeof EventMemberDetailSchema>;
